// src/pages/student/Dashboard.js
const Dashboard = () => <h1>Student Dashboard</h1>;
export default Dashboard;
